import { useEffect } from 'react';
import { UserAuth } from '../../middleware/UserContext/UserContext.middleware';
import { useCurrentUserStore } from '../stores/currentUser.store';

export const useCurrentUser = () => {
  const { currentUser: firebaseUser } = UserAuth();
  const { user, loadedFor, isLoading, error, load, reset } = useCurrentUserStore();

  useEffect(() => {
    if (firebaseUser) {
      load(firebaseUser.uid);
    } else {
      reset();
    }
  }, [firebaseUser, load, reset]);

  const isResolved = !firebaseUser || (loadedFor === firebaseUser.uid && !isLoading);

  return {
    user,
    isAdmin: Boolean(user?.isAdmin),
    isResolved,
    error,
  };
};
